<template>
  <div class="cores">
    <template>
      <v-card>
        <v-card-title>
          Decision Engine Config
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card>
          <v-container fluid>
            <v-select
              :items="statesList"
              :clearable="true"
              @change="selectState()"
              v-model="selectedState"
              label="Select State"
            ></v-select>

            <v-row>
              <v-data-table
                :headers="headers"
                :items="displayedStateConfigs"
                class="elevation-2">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.fiState }}</td>
                    <td>{{ props.item.fiid }}</td>
                    <td>{{ props.item.fiName }}</td>
                    <td>{{ props.item.personalRedirectUrl }}</td>
                    <td>{{ props.item.autoRedirectUrl }}</td>
                    <td>{{ props.item.personalLoanAppDestination }}</td>
                    <td>{{ props.item.vehicleLoanAppDestination }}</td>
                    <td>{{ props.item.apiUrl }}</td>
                    <td>{{ props.item.refId }}</td>
                    <td>
                      <v-btn v-if="userWritePrivileges"
                        color="red"
                        dark
                        @click="deleteFiid(props.item)">
                      <font-awesome-icon icon="trash-alt" class="pr-1" />Delete
                      </v-btn>
                    </td>
                    <td>
                      <v-btn v-if="userWritePrivileges"
                        color="info"
                        dark
                        @click="editFields(props.item)">
                        <font-awesome-icon icon="edit" class="pr-1"/>Edit
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
            </v-row>
            <v-row>
              <v-btn v-if="userWritePrivileges"
                color="info"
                dark
                @click="addNewFi()">
                <font-awesome-icon icon="plus-square" class="pr-1"/>New
              </v-btn>
            </v-row>
          </v-container>
        </v-card>
      </v-card>

      <v-dialog
        v-model="editDialog"
        persistent
        max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit FI ID</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                  disabled
                  :value="placeholderFiState"
                  label="State">
                  </v-text-field>
                  <v-text-field
                  disabled
                  label="FI ID"
                  :value="placeholderFiid">
                  </v-text-field>
                  <v-text-field
                  v-model="editFiName"
                  type="text"
                  label="FI Name"
                  :rules="['Required']"
                  :placeholder="placeholderFiName">
                  </v-text-field>
                  <v-text-field
                  v-model="editPersonalRedirectUrl"
                  type="text"
                  label="Personal Redirect Url"
                  :placeholder="placeholderPersonalRedirectUrl">
                  </v-text-field>
                  <v-text-field
                  v-model="editAutoRedirectUrl"
                  type="text"
                  label="Auto Redirect Url"
                  :placeholder="placeholderAutoRedirectUrl">
                  </v-text-field>
                  <v-select
                    :items="loanAppDestinations"
                    v-model="editPersonalLoanAppDestination"
                    label="Personal Loan App Destination"
                  ></v-select>
                  <v-select
                    :items="loanAppDestinations"
                    v-model="editVehicleLoanAppDestination"
                    label="Vehicle Loan App Destination"
                  ></v-select>
                  <v-text-field
                  v-model="editApiUrl"
                  type="text"
                  label="API Url"
                  :placeholder="placeholderApiUrl">
                  </v-text-field>
                  <v-text-field
                  v-model="editRefId"
                  type="text"
                  label="Reference Id"
                  :placeholder="placeholderRefId">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeEdit()">Cancel</v-btn>
            <v-btn color="blue darken-1" text
            @click="saveEditedFields()">Save Changes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Add FI</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                  v-model="newState"
                  type="text"
                  label="State"
                  :rules="['Required']">
                  </v-text-field>
                  <v-text-field
                  v-model="newFiid"
                  type="text"
                  label="FI ID"
                  :rules="['Required']">
                  </v-text-field>
                  <v-text-field
                  v-model="newFiName"
                  type="text"
                  label="FI Name"
                  :rules="['Required']">
                  </v-text-field>
                   <v-text-field
                  v-model="newPersonalRedirectUrl"
                  type="text"
                  label="Personal Redirect Url">
                  </v-text-field>
                  <v-select
                    :items="loanAppDestinations"
                    v-model="newPersonalLoanAppDestination"
                    label="Personal App Loan Destination"
                  ></v-select>
                  <v-select
                    :items="loanAppDestinations"
                    v-model="newVehicleLoanAppDestination"
                    label="Vehicle App Loan Destination"
                  ></v-select>
                  <v-text-field
                  v-model="newAutoRedirectUrl"
                  type="text"
                  label="Auto Redirect Url">
                  </v-text-field>
                  <v-text-field
                  v-model="newApiUrl"
                  type="text"
                  label="API Url">
                  </v-text-field>
                  <v-text-field
                  v-model="newRefId"
                  type="text"
                  label="Reference Id">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="addFiid()">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import MeridianLinkService from '@/MeridianLinkService';
import RequestService from '@/RequestService';

@Component
export default class MeridianLinkConfig extends Vue {
  /*eslint-disable */
  data() {
    return {
      dialog: false,
      editDialog: false,
      userWritePrivileges: false,
    };
  }

  /* eslint-enable */
  displayedStateConfigs=[];

  allConfigs = [];

  loanAppDestinations = [
    { text: 'Meridian Link', value: 'meridianLink' },
    { text: 'RateGenius', value: 'rateGenius' },
  ]

  selectedState = '';

  // new = for all the pop up window fields
  newPersonalRedirectUrl = '';

  newAutoRedirectUrl = '';

  newApiUrl = '';

  newState = '';

  newFiName = '';

  newFiid = '';

  newRefId = '';

  newPersonalLoanAppDestination = '';

  newVehicleLoanAppDestination = '';

  // edit fields
  editPersonalRedirectUrl = '';

  editAutoRedirectUrl = '';

  editApiUrl = '';

  editFiName = '';

  editRefId = '';

  editPersonalLoanAppDestination = '';

  editVehicleLoanAppDestination = '';

  statesList = [];

  // placeholder fields
  placeholderFiState = '';

  placeholderFiid = '';

  placeholderPersonalRedirectUrl = '';

  placeholderAutoRedirectUrl = '';

  placeholderApiUrl = '';

  placeholderFiName = '';

  placeholderRefId = '';

  placeholderPersonalLoanAppDestination = '';

  placeholderVehicleLoanAppDestination = '';

  headers = [
    {
      text: 'State', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'FI ID', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'FI Name', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'Personal Redirect Url', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'Auto Redirect Url', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'Personal Loan App Destination', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'Vehicle Loan App Destination', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'API Url', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'Reference Id', value: 'item', sortable: true, align: 'left',
    },
  ];

  emptyPayload = {
    fiState: '',
    fiid: '',
    fiName: '',
    personalRedirectUrl: '',
    autoRedirectUrl: '',
    personalLoanAppDestination: '',
    vehicleLoanAppDestination: '',
    apiUrl: '',
    refId: '',
  };

  async addFiid() {
    const editedPayload = this.emptyPayload;

    let existingFiid = false;
    Object.keys(this.allConfigs).forEach((idx) => {
      if (this.allConfigs[idx].fiState === this.newState && this.allConfigs[idx].fiid === this.newFiid) {
        existingFiid = true;
      }
    });

    if (existingFiid) {
      window.alert(`FI ID ${this.newFiid} already exists in ${this.newState}.`);
    } else if (this.newState.trim() === '') {
      window.alert('State cannot be blank.');
    } else if (this.newFiid.trim() === '') {
      window.alert('FI ID cannot be blank.');
    } else if (this.newFiName.trim() === '') {
      window.alert('FI Name cannot be blank.');
    } else if (window.confirm(`Are you sure you want to add FI ID: ${this.newFiid}`
      + ` to: ${this.newState}?`)) {
      this.dialog = true;

      editedPayload.fiid = this.newFiid;
      editedPayload.fiState = this.newState;
      editedPayload.fiName = this.newFiName;
      editedPayload.apiUrl = this.newApiUrl;
      editedPayload.personalRedirectUrl = this.newPersonalRedirectUrl;
      editedPayload.autoRedirectUrl = this.newAutoRedirectUrl;
      editedPayload.personalLoanAppDestination = this.newPersonalLoanAppDestination;
      editedPayload.vehicleLoanAppDestination = this.newVehicleLoanAppDestination;
      editedPayload.refId = this.newRefId;

      await MeridianLinkService.postMeridianLinkConfig(editedPayload);

      this.allConfigs = await MeridianLinkService.getAllConfigs();
      this.statesList = await MeridianLinkService.getStatesList(this.allConfigs);
      await this.selectState();

      this.newFiid = Object.assign('', this.newFiid);
      this.newState = '';
      this.newPersonalRedirectUrl = '';
      this.newAutoRedirectUrl = '';
      this.newPersonalLoanAppDestination = '';
      this.newVehicleLoanAppDestination = '';
      this.newApiUrl = '';
      this.newFiName = '';
      this.newRefId = '';
      this.close();
    }
  }

  async addNewFi() {
    this.newFiid = this.placeholderFiid;
    this.newState = this.placeholderFiState;
    this.newPersonalRedirectUrl = this.placeholderPersonalRedirectUrl;
    this.newAutoRedirectUrl = this.placeholderAutoRedirectUrl;
    this.newPersonalLoanAppDestination = this.placeholderPersonalLoanAppDestination;
    this.newVehicleLoanAppDestination = this.placeholderVehicleLoanAppDestination;
    this.newApiUrl = this.placeholderApiUrl;
    this.newFiName = this.placeholderFiName;
    this.newRefId = this.placeholderRefId;

    this.dialog = true;
  }

  async editFields(item) {
    this.placeholderFiState = item.fiState;
    this.placeholderFiid = item.fiid;
    this.placeholderFiName = item.fiName;
    this.placeholderPersonalRedirectUrl = item.personalRedirectUrl;
    this.placeholderAutoRedirectUrl = item.autoRedirectUrl;
    this.editPersonalLoanAppDestination = item.personalLoanAppDestination;
    this.editVehicleLoanAppDestination = item.vehicleLoanAppDestination;
    this.placeholderApiUrl = item.apiUrl;
    this.placeholderRefId = item.refId;

    this.editDialog = true;
  }

  async saveEditedFields() {
    const editedPayload = this.emptyPayload;
    if (this.allEditFieldsEmptyOrNoChanges()) {
      window.alert('No changes made!');
      this.closeEdit();
      return;
    }

    if (this.editPersonalRedirectUrl.trim() === '') {
      this.editPersonalRedirectUrl = this.placeholderPersonalRedirectUrl;
    }
    if (this.editAutoRedirectUrl.trim() === '') {
      this.editAutoRedirectUrl = this.placeholderAutoRedirectUrl;
    }
    if (this.editApiUrl.trim() === '') {
      this.editApiUrl = this.placeholderApiUrl;
    }
    if (this.editFiName.trim() === '') {
      this.editFiName = this.placeholderFiName;
    }
    if (this.editRefId.trim() === '') {
      this.editRefId = this.placeholderRefId;
    }
    if (this.editPersonalLoanAppDestination.trim() === '') {
      this.editPersonalLoanAppDestination = this.placeholderPersonalLoanAppDestination;
    }
    if (this.editVehicleLoanAppDestination.trim() === '') {
      this.editVehicleLoanAppDestination = this.placeholderVehicleLoanAppDestination;
    }

    if (window.confirm(`Are you sure you want to edit FI ID: ${this.placeholderFiid}`
      + ` in: ${this.placeholderFiState}?`)) {
      this.editDialog = true;

      editedPayload.fiid = this.placeholderFiid;
      editedPayload.fiState = this.placeholderFiState;
      editedPayload.fiName = this.editFiName;
      editedPayload.apiUrl = this.editApiUrl;
      editedPayload.personalRedirectUrl = this.editPersonalRedirectUrl;
      editedPayload.autoRedirectUrl = this.editAutoRedirectUrl;
      editedPayload.personalLoanAppDestination = this.editPersonalLoanAppDestination;
      editedPayload.vehicleLoanAppDestination = this.editVehicleLoanAppDestination;
      editedPayload.refId = this.editRefId;

      await MeridianLinkService.postMeridianLinkConfig(editedPayload);

      this.allConfigs = await MeridianLinkService.getAllConfigs();
      this.statesList = await MeridianLinkService.getStatesList(this.allConfigs);
      await this.selectState();

      this.editPersonalRedirectUrl = '';
      this.editAutoRedirectUrl = '';
      this.editPersonalLoanAppDestination = '';
      this.editVehicleLoanAppDestination = '';
      this.editApiUrl = '';
      this.editFiName = '';
      this.editRefId = '';
      this.closeEdit();
    }
  }

  allEditFieldsEmptyOrNoChanges() {
    if ((this.editPersonalRedirectUrl.trim() === ''
        || this.editPersonalRedirectUrl.trim() === this.placeholderPersonalRedirectUrl)
    && (this.editAutoRedirectUrl.trim() === ''
        || this.editAutoRedirectUrl.trim() === this.placeholderAutoRedirectUrl)
    && (this.editPersonalLoanAppDestination.trim() === ''
        || this.editPersonalLoanAppDestination.trim() === this.placeholderVehicleLoanAppDestination)
    && (this.editVehicleLoanAppDestination.trim() === ''
        || this.editVehicleLoanAppDestination.trim() === this.placeholderVehicleLoanAppDestination)
    && (this.editApiUrl.trim() === '' || this.editApiUrl.trim() === this.placeholderApiUrl)
    && (this.editFiName.trim() === '' || this.editFiName.trim() === this.placeholderFiName)
    && (this.editRefId.trim() === '' || this.editRefId.trim() === this.placeholderRefId)) {
      return true;
    }
    return false;
  }

  async deleteFiid(item) {
    if (window.confirm(`Are you sure you want to delete FI ID: ${item.fiid} `
    + `with FI Name: ${item.fiName} in ${item.fiState}?`)) {
      const payload = this.emptyPayload;
      payload.fiState = item.fiState;
      payload.fiid = item.fiid;
      payload.fiName = item.fiName;
      payload.personalRedirectUrl = item.personalRedirectUrl;
      payload.autoRedirectUrl = item.autoRedirectUrl;
      payload.personalLoanAppDestination = item.personalLoanAppDestination;
      payload.vehicleLoanAppDestination = item.vehicleLoanAppDestination;
      payload.apiUrl = item.apiUrl;
      payload.refId = item.refId;

      await MeridianLinkService.deleteMeridianLinkConfig(JSON.parse(JSON.stringify(payload)));

      this.allConfigs = await MeridianLinkService.getAllConfigs();
      this.statesList = await MeridianLinkService.getStatesList(this.allConfigs);
      await this.selectState();
    }
  }

  selectState() {
    if (this.selectedState !== undefined && this.selectedState !== '') {
      this.displayedStateConfigs = this.allConfigs.filter(data => data.fiState === this.selectedState);
    } else {
      this.displayedStateConfigs = this.allConfigs;
    }
  }

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.newFiid = '';
      this.newPersonalRedirectUrl = '';
      this.newAutoRedirectUrl = '';
      this.newApiUrl = '';
      this.newState = '';
      this.newFiName = '';
      this.newRefId = '';
    }, 300);
  }

  closeEdit() {
    this.editDialog = false;

    this.placeholderFiState = '';
    this.placeholderFiid = '';
    this.placeholderFiName = '';
    this.placeholderPersonalRedirectUrl = '';
    this.placeholderAutoRedirectUrl = '';
    this.placeholderPersonalLoanAppDestination = '';
    this.placeholderVehicleLoanAppDestination = '';
    this.placeholderApiUrl = '';
    this.placeholderRefId = '';

    setTimeout(() => {
      this.editPersonalRedirectUrl = '';
      this.editAutoRedirectUrl = '';
      this.editPersonalLoanAppDestination = '';
      this.editVehicleLoanAppDestination = '';
      this.editApiUrl = '';
      this.editFiName = '';
      this.editRefId = '';
    }, 300);
  }

  async mounted() {
    this.userWritePrivileges = await RequestService.checkCredentials();
    this.allConfigs = await MeridianLinkService.getAllConfigs();
    this.statesList = await MeridianLinkService.getStatesList(this.allConfigs);
    this.displayedStateConfigs = this.allConfigs;
  }
}
</script>
